import React from 'react';
import Background from '../../../../../static/img/bg-select.png';
import { Breadcrumb, Row, Col, Menu, Button, DatePicker, List, Spin, Select, Dropdown } from 'antd';
import { Line } from '@ant-design/plots';
import {
  queryDeviceUsageByMonth, companyDeviceTrend, queryCompanyApplicensesList, companyDevicesTypeList
} from "./gqls";
import Client from '../../../../../lib/gqlClient';
import getWantTimestamp from '../../../../../lib/utils/times'
import moment from 'moment-timezone';
import { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom'
const CompanyUsage = (props) => {
  const navigate = useNavigate();
  const location = useLocation()
  const { state } = location
  const appId = state.companyId


  const [isSelectDeviceOrMeasureLoading, setSelectDeviceOrMeasureLoading] = useState(false)
  let isSelectDeviceOrMeasure = true//true app  false  companies
  const [deviceOrMeasureSelectItem, setDeviceOrMeasureSelectItem] = useState(3)//默认显示全年 1本月 2本季度 3全年
  const [listData, setListData] = useState([])
  const [listTypeName, setListTypeName] = useState('总使用设备数')
  const [listDataName, setListDataName] = useState('总使用设备数趋势')
  const [selectTypeList, setSelectTypeList] = useState([])//当前展示list
  const [selectData, setSelectData] = useState("Select device type")//当前选择类型



  const [isDeviceUsageByMonthLoading, setDeviceUsageByMonthLoading] = useState(false)
  const [deviceUsageByMonth, setDeviceUsageByMonth] = useState([])
  const [isCompanyApplicensesListLoading, setCompanyApplicensesListLoading] = useState(false)
  const [companyApplicensesList, setCompanyApplicensesList] = useState([])
  const [isSelectPemanent, setSelectPemanent] = useState(true)
  React.useEffect(() => {
    getDeviceType()
    isGetSelectDeviceOrMeasure(deviceOrMeasureSelectItem)
    let year = moment().utc().year();
    let month = moment().utc().month() + 1;
    getDeviceUsageByMonth(year, month)
    getCompanyApplicenses(true)

    window.history.pushState(null, null, document.URL);
        window.onpopstate = function (PopStateEvent) {
            window.history.pushState(null, null, document.URL);
            props.setNewKey('developerCenter/companyList')
            navigate('/developerCenter/companyList', {
              replace: false, 
              state: {
                seatchData: state.seatchData,
                page: state.page,
                showSize: state.showSize
              }
            })
        };
        return () => {
            // 回退事件只用于当前组件，则需要在组件销毁时把回退事件销毁
            window.onpopstate = null;
        };
  }, [])
  function getDeviceType() {
    //设备类型
    Client(
      companyDevicesTypeList,
      {
        company: appId,
      }
    ).then((res) => {
      console.log(res)
      if (res !== null) {
        console.log("companyDevicesTypeList:" + res.data.companyDevicesTypeList)
        setSelectTypeList(res.data.companyDevicesTypeList)
      }
    }).catch(e => {
      console.log(e.key);
    })
  }
  function onClick(e) {
    if (e.key === "1") {
      isSelectDeviceOrMeasure = true
      setSelectData("Select device type")
      setListDataName('总使用设备数趋势')
    } else {
      isSelectDeviceOrMeasure = false
      setSelectData("Select device type")
      setListDataName('总测量数据趋势')
    }
    isGetSelectDeviceOrMeasure(deviceOrMeasureSelectItem)
  }
  function handleChange(e) {
    setSelectData(e)
    if (listTypeName === '总使用设备数') {
      isSelectDeviceOrMeasure = true
    } else {
      isSelectDeviceOrMeasure = false
    }
    isGetSelectDeviceOrMeasure(deviceOrMeasureSelectItem, e)
  }
  function btnSelectDeviceOrMeasure(type) {
    if (listTypeName === '总使用设备数') {
      isSelectDeviceOrMeasure = true
    } else {
      isSelectDeviceOrMeasure = false
    }
    isGetSelectDeviceOrMeasure(type, selectData)

  }
  function isGetSelectDeviceOrMeasure(type, selectType) {
    setDeviceOrMeasureSelectItem(type)
    var months = []
    switch (type) {
      case 1:
        months = getWantTimestamp("thisYearDayZero");
        break;
      case 2:
        months = getWantTimestamp("threeMonthDayZeroList");
        break;
      case 3:
        let month = moment().utc().month() + 1;
        let list = []
        for (let index = 0; index < month; index++) {
          list[index] = index + 1
        }
        months = list;
        break;
      default: {
        console.log("类型错误");
        return months = [];
      }
    }
    let year = moment().utc().year();
    console.log(isSelectDeviceOrMeasure, type, months, year, selectType)

    if ("Select device type" === selectType) {
      getCompanyDeviceTrend(type, months, year)
    } else {
      getCompanyDeviceTrend(type, months, year, selectType)
    }
  }
  function getCompanyDeviceTrend(type, months, year, selectType) {
    setSelectDeviceOrMeasureLoading(true)
    Client(
      companyDeviceTrend,
      {
        company: appId,
        year: year,
        months: months,
        deviceModel: selectType
      }
    ).then((res) => {
      console.log(res)
      if (res !== null) {
        let data = [{}];
        const list = res.data.companyDeviceTrend
        console.log(list)
        if (isSelectDeviceOrMeasure) {
          list.map((item, index) => {
            data[index] = {
              Date: item.year + "-" + item.month,
              总使用设备数: item.deviceCount
            }
          })
          setListTypeName('总使用设备数')
        } else {
          list.map((item, index) => {
            data[index] = {
              Date: item.year + "-" + item.month,
              总测量数据: item.measureCount,
            }
          })
          setListTypeName('总测量数据')
        }
        setListData(data)
      }
      setSelectDeviceOrMeasureLoading(false)
    }).catch(e => {
      // console.log(e);
      setSelectDeviceOrMeasureLoading(false)
    })
  }
  //切换月份数据
  function onChange(date, dateString) {
    let year = date.utc().year();
    let month = date.utc().month() + 1;
    console.log(year, month);
    getDeviceUsageByMonth(year, month)
  }
  function getDeviceUsageByMonth(year, months) {
    setDeviceUsageByMonthLoading(true)
    Client(
      queryDeviceUsageByMonth,
      {
        company: appId,
        year: year,
        month: months,
      }
    ).then((res) => {
      console.log(res)
      if (res !== null) {
        const list = res.data.getDeviceUsageByMonth
        console.log(list)
        setDeviceUsageByMonth(list)
      }
      setDeviceUsageByMonthLoading(false)
    }).catch(e => {
      // console.log(e);
      setDeviceUsageByMonthLoading(false)
    })
  }
  function getCompanyApplicenses(e) {
    setCompanyApplicensesListLoading(true)
    Client(
      queryCompanyApplicensesList,
      {
        company: appId,
      }
    ).then((res) => {
      if (res !== null) {
        const list = res.data.getCompanyApplicensesList
        const listTwo = []
        list.map((item, index) => {
          if (item.isPermanent && e) {
            listTwo[listTwo.length] = item
          } else if (!item.isPermanent && !e) {
            listTwo[listTwo.length] = item
          }
        })
        console.log(listTwo)
        setCompanyApplicensesList(listTwo)
        setSelectPemanent(e)
      }
      setCompanyApplicensesListLoading(false)
    }).catch(e => {
      // console.log(e);
      setCompanyApplicensesListLoading(false)
    })
  }
  function onIsSelectPemanent(e) {

    if (e.key === '2') {
      getCompanyApplicenses(false)
    } else {
      getCompanyApplicenses(true)
    }
  }
  function onStart() {
    props.setNewKey('developerCenter/dataNotification')
    navigate('/developerCenter/dataNotification')
  }
  function onStartCompanyList() {
    props.setNewKey('developerCenter/companyList')
    navigate('/developerCenter/companyList', {
      replace: false, 
      state: {
        seatchData: state.seatchData,
        page: state.page,
        showSize: state.showSize
      }
    })
  }
  return (
    <div style={{ height: '100%', width: '100%', }}>
      {/* 标题头 */}
      <div style={{ height: '503px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
        <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
          <Breadcrumb.Item><Link to='../../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
          <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>SDK Dashboard</a></Breadcrumb.Item>
          <Breadcrumb.Item><a onClick={onStartCompanyList} style={{ fontSize: '12px' }}>公司列表</a></Breadcrumb.Item>
          <Breadcrumb.Item><a style={{ fontSize: '12px' }}>Company Usage</a></Breadcrumb.Item>
        </Breadcrumb>
        <li style={{ textAlign: 'center', marginTop: '8px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #000' }}>
          公司使用趋势</li>
        <div style={{ height: '404px', padding: '0px', marginTop: '40px' }}>
          <div style={{ height: '55px', padding: '0px', }}>
            <Row>
              <Col span={12}>
                <Menu defaultSelectedKeys={['1']}
                  mode="horizontal"
                  style={{ justifyContent: 'start' }}
                  items={items}
                  onClick={onClick}>
                </Menu>
              </Col>
              <Col span={12} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                <Select value={selectData} style={{ width: '256px', }} onChange={handleChange}>
                  {selectTypeList.map(it => (
                    <Select.Option value={it}>
                      {it}
                    </Select.Option>
                  ))}
                </Select>
                <Button className="btn" onClick={() => btnSelectDeviceOrMeasure(2)} type="text" style={{ color: (deviceOrMeasureSelectItem === 2 ? '#2657F9' : '#000'), border: 'none' }}>本季度</Button>
                <Button className="btn" onClick={() => btnSelectDeviceOrMeasure(3)} type="text" style={{ color: (deviceOrMeasureSelectItem === 3 ? '#2657F9' : '#000'), border: 'none', marginRight: '18px' }}>本年</Button>
              </Col>
            </Row>
            <div style={{ height: '1px', backgroundColor: '#E8E8E8' }} />
          </div>
          <a style={{ marginLeft: '56px', marginTop: '24px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #2657F9' }}>
            {listDataName}</a>
          <Spin size="large" tip="Loading..." spinning={isSelectDeviceOrMeasureLoading}>
            <Line{...{
              data: listData,
              padding: 'auto',
              xField: 'Date',
              yField: listTypeName,
              meta: {
                alias: '111'
              },

              smooth: true,
              lineStyle: { r: 1, stroke: "#1890FF", strokeOpacity: 1, },
            }} style={{ height: '246px', marginTop: '20px', marginBottom: '33px', marginLeft: '99px', marginRight: '94px' }} />
          </Spin>
        </div>
      </div>
      <div style={{ height: '460px', padding: '0px', backgroundColor: 'white', borderRadius: '2px', marginTop: '15px' }}>
        <li style={{ textAlign: 'center', paddingTop: '30px', paddingBottom: '40px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #000', }}>
          公司月使用详情</li>
        <div style={{ height: '55px', padding: '0px', }}>
          <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
            <DatePicker showToday={true} onPanelChange={onChange} picker="month"
              style={{ height: '32px', width: '256px', marginRight: '32px', }} />
          </div>
          <Row style={Styles.listTitleBg}>
            <Col span={8} style={Styles.listTitleText}>
              Device Model
            </Col>
            <Col span={8} style={Styles.listTitleText}>
              Device in Use in this Month
            </Col>
            <Col span={8} style={Styles.listTitleText}>
              Measurement in this Month
            </Col>
          </Row>
          <Spin size="large" tip="Loading..." spinning={isDeviceUsageByMonthLoading}>
            <List
              style={{ marginLeft: '32px', marginRight: '32px' }}
              itemLayout="vertical"
              split="true"
              pagination={{
                pageSize: 4,
                hideOnSinglePage: true,
                showSizeChanger: false,
                total: deviceUsageByMonth.length
              }}
              position="bottom"
              dataSource={deviceUsageByMonth}
              renderItem={(item) => (
                <List.Item style={Styles.item}>
                  <Row >
                    <Col span={8} style={Styles.listTitleText}>
                      {item.deviceModel}
                    </Col>
                    <Col span={8} style={Styles.listTitleText}>
                      {item.activeCount}
                    </Col>
                    <Col span={8} style={Styles.listTitleText}>
                      {item.measureCount}
                    </Col>
                  </Row>
                </List.Item>
              )}
            />
          </Spin>
        </div>
      </div>
      <div style={{ height: '460px', padding: '0px', backgroundColor: 'white', borderRadius: '2px', marginTop: '15px', marginBottom: '15px' }}>
        <li style={{ textAlign: 'center', paddingTop: '30px', paddingBottom: '40px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #000', }}>
          公司App详情</li>
        <div style={{ height: '55px', padding: '0px', }}>
          <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
            <Dropdown overlay={<Menu onClick={onIsSelectPemanent} items={item} />} placement="bottomLeft"  >
              <Row style={Styles.selectBg}>
                <Col style={{ width: '128px' }}>
                  <span style={{ paddingLeft: '12px' }} > Is Permanent</span>
                </Col>
                <Col style={{ width: '128px' }}>
                  <span style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', marginRight: '12px' }} >{isSelectPemanent ? 'Yes' : 'No'}</span>
                </Col>
              </Row>
            </Dropdown>
          </div>
          <Row style={Styles.listTitleBg}>
            <Col span={4} style={Styles.listTitleText}>
              App Name
            </Col>
            <Col span={4} style={Styles.listTitleText}>
              Solutions
            </Col>
            <Col span={4} style={Styles.listTitleText}>
              Platform
            </Col>
            <Col span={4} style={Styles.listTitleText}>
              License Expired
            </Col>
            <Col span={4} style={Styles.listTitleText}>
              Is Permanent
            </Col>
            <Col span={4} style={Styles.listTitleText}>
              Permanent Date
            </Col>
          </Row>
          <Spin size="large" tip="Loading..." spinning={isCompanyApplicensesListLoading}>
            <List
              style={{ paddingLeft: '32px', paddingRight: '32px', backgroundColor: 'white', borderRadius: '2px', }}
              itemLayout="vertical"
              split="true"
              pagination={{
                pageSize: 20,
                hideOnSinglePage: true,
                showSizeChanger: false,
                total: companyApplicensesList.length
              }}
              dataSource={companyApplicensesList}
              renderItem={(item) => (
                <List.Item style={Styles.item}>
                  <Row >
                    <Col span={4} style={Styles.listTitleText}>
                      {item.appName}
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                      {item.sdkType}
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                      {item.platform}
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                      {String(item.expireTime).substring(0, 10)}
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                      {item.isPermanent ? "Yes" : "No"}
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                      {String(item.permanentTime).substring(0, 10)}
                    </Col>
                  </Row>
                </List.Item>
              )}
            />
          </Spin>
        </div>
      </div>
    </div>
  );
}
function getItem(label, key,) {
  return {
    key,
    label,
  };
}
const items = [
  getItem('总使用设备数', '1'),
  getItem('总测量数据', '2'),
];
const Styles = {
  listTitleBg: {
    height: '54px',
    padding: '0px',
    backgroundColor: '#F3F3F3',
    borderRadius: '2px',
    marginTop: '10px',
    marginLeft: '32px',
    marginRight: '32px'
  },
  listTitleText: {
    fontSize: '14px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px'
  },
  selectBg: {
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%, 100%',
    marginRight: '32px',
    paddingTop: '5px',
    paddingBottom: '5px',
    height: '32px',
    width: '256px',
    color: '#000'
  },
  item: {
    height: '54px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%, 100%',
  },
}
const item = [
  {
    key: '1',
    label: (
      <a target="_blank" rel="noopener noreferrer">
        Yes
      </a>
    ),
  }, {
    key: '2',
    label: (
      <a target="_blank" rel="noopener noreferrer">
        No
      </a>
    ),
  }]
export default CompanyUsage